module.exports = __webpack_public_path__ + "7f515255733f4d3c001e976555dca366.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/familyActivities/Assets/Fruit_and_Veg_Flashcards.png
// module id = 1361
// module chunks = 0